/*
 * @Author: your name
 * @Date: 2020-12-10 18:15:19
 * @LastEditTime: 2024-01-15 16:41:59
 * @LastEditors: wuchengcheng
 * @Description: In User Settings Edit
 * @FilePath: /web-platform/src/dictionary/notice.js
 */
/**
 * 设置pageType的规则：根据一级标题占第一位、二级标题占第二位、具体路由占第三位的原则进行定义
 * 若任何一个超出一位，则使用字符串，中间用横杠分割
 * X_YY_ZZ_MM: X代表平台（P: 采购工作台、A: 代理机构工作台、S:供应商）
 * YY代表功能(Purchase: 采购，Statistics：查询统计)
 * ZZ代表采购方式
 * MM代表相应页面
 */
import Dict from '@/utils/dict-utils'
import { platformFunctionModuleDict } from '@/dictionary/system'

export const noticeDict = {
  /** ************************招标*******************************/

  /** ********招标***********/
  100: {
    [platformFunctionModuleDict.PURCHASER.right]: 'BiddingApply', //  采购人 - 招标 - 报名情况页面
    [platformFunctionModuleDict.AGENCY.right]: 'AgencyBiddingApply' //  代理机构 - 招标 - 报名情况页面
  },
  102: {
    [platformFunctionModuleDict.PURCHASER.right]: 'BiddingApply', //  采购人 - 招标 - 报名情况页面
    [platformFunctionModuleDict.AGENCY.right]: 'AgencyBiddingApply' //  代理机构 - 招标 - 报名情况页面
  },

  /** ********委托***********/
  101: {
    [platformFunctionModuleDict.PURCHASER.right]: 'PurchaserEntrustDetail', // 采购人-代理机构接受、拒绝委托
    [platformFunctionModuleDict.AGENCY.right]: 'AgencyEntrustDetail' // 代理机构 - 收到采购人委托
  },

  /** ********询比***********/
  110: {
    [platformFunctionModuleDict.PURCHASER.right]: 'InquiryOfferAccepted', // 采购人 - 询比 - 报名情况页面
    [platformFunctionModuleDict.AGENCY.right]: 'AgencyInquiryOfferAccepted' // 代理机构 - 询比 - 报名情况页面
  },
  111: {
    [platformFunctionModuleDict.PURCHASER.right]: 'InquiryOfferAccepted', // 采购人 - 询比 - 接受报价中(有新供应商报价)
    [platformFunctionModuleDict.AGENCY.right]: 'AgencyInquiryOfferAccepted' // 代理机构 - 询比 - 接受报价中(有新供应商报价)
  },
  112: {
    [platformFunctionModuleDict.PURCHASER.right]: 'InquiryInviteDetail', // 采购人 -询比 - 邀请函详情页
    [platformFunctionModuleDict.AGENCY.right]: 'AgencyInquiryInviteDetail' // 代理机构 -询比 - 邀请函详情页
  },

  /** ********竞价***********/
  120: {
    [platformFunctionModuleDict.PURCHASER.right]: 'SignUpSituation', // 采购人 - 竞价 - 接受报名中
    [platformFunctionModuleDict.AGENCY.right]: 'AgencySignUpSituation' // 代理机构 - 竞价 - 接受报名中
  },
  121: {
    [platformFunctionModuleDict.PURCHASER.right]: 'SignUpSituation', // 采购人 - 竞价 - 邀请详情
    [platformFunctionModuleDict.AGENCY.right]: 'AgencySignUpSituation' // 代理机构 - 竞价 - 邀请详情
  },
  122: {
    [platformFunctionModuleDict.PURCHASER.right]: 'CompeteHallDoor', // 采购人 - 竞价 - 进入竞价大厅
    [platformFunctionModuleDict.AGENCY.right]: 'AgencyCompeteHallDoor' // 代理机构 - 竞价 - 进入竞价大厅
  },
  123: 'InviteCompeteHallMiddle', // 竞价 - 嘉宾进入竞价大厅
  124: {
    [platformFunctionModuleDict.PURCHASER.right]: 'SupplierCompeteSignUp', // 采购人 - 竞价 - 供应商进入竞价大厅
    [platformFunctionModuleDict.AGENCY.right]: 'AgencySupplierCompeteSignUp' // 代理机构 - 竞价 - 供应商进入竞价大厅
  },

  /** ******供应商招募******* */
  130: 'RecruitApplyInfo', // 供应商招募 - 报名列表页

  /** **********谈判采购*********** */
  140: 'NegotiationResponse', //  采购人  - 报名情况页面
  141: 'NegotiationResponse', //  采购人  - 邀请函详情页

  /** ************分项谈判*************** */
  160: 'NegotiationV2Quote', // 采购人 - 报名详情页面
  161: 'NegotiationV2Quote', // 采购人 - 邀请函详情页

  /** **************项目异议*******************/
  180: {
    [platformFunctionModuleDict.PURCHASER.right]: 'ObjectionList', // 采购人 - 项目异议
    [platformFunctionModuleDict.AGENCY.right]: 'AgencyObjectionList' // 代理机构 - 项目异议
  },

  /** **************风险治理*******************/
  190: 'RiskManageHandle', // 采购人  - 风险记录与处理
  191: 'RiskSuperviseTask', // 采购人  - 督办任务管理-任务查询

  /** ****************直接采购 P:采购人****************** */
  P_Purchase_Direct_Detail: 'DirectPurchaseDetail', // 直接采购

  /** ************************投标*******************************/
  201: 'SupplierPurchaseSignUp', //  供应商 - 招标采购详情
  202: 'PurchaseLetter', // 供应商 - 招标邀请函详情
  203: 'SupplierPurchaseSignUp', // 供应商 - 招标信息变更页面
  204: 'SupplierPurchaseSignUp', // 供应商 - 招标文件澄清
  211: 'SupplierInquiryTrade', // 供应商 - 询比报价详情
  212: 'InquiryLetter', // 供应商 - 询比邀请函详情
  213: 'SupplierInquiryTrade', //  供应商 - 询比信息变更页面
  221: 'SupplierCompeteSignUp', // 供应商 - 竞价报名
  222: 'CompeteLetter', // 供应商 - 竞价邀请函详情
  223: 'SupplierCompeteSignUp', // 供应商 - 竞价变更公告页面
  230: 'SupplierRecruitTrade', // 供应商 - 招募详情页
  241: 'SupplierNegotiationTrade', // 供应商- 谈判采购详情
  242: 'NegotiationLetter', // 供应商 - 谈判采购邀请函详情
  251: 'SupplierOrderCollaborateDetail', // 供应商-订单协同
  261: 'SupplierNegotiationV2Trade', // 供应商 - 分项谈判报名页面
  262: 'NegotiationV2Letter', // 供应商 - 分项谈判邀请函详情

  /** ****************直接采购****************** */
  S_Purchase_Direct_Detail: 'DirectPurchaseDetail', // 直接采购

  /** ************************企业管理*******************************/
  300: 'Department', // 企业管理 - 部门管理页面

  /** ************************订单管理*******************************/
  431: 'DemandOrderDetail', // 订单管理-订单详情
  400: 'DemandOrderDetail', // 订单管理-订单详情

  /** **************（公共页面）*******************/
  500: 'ToDoListAuditDetail', // 待办事项 - 审批详情页
  501: 'SignatureTask', // 在线签章审批页面

  /** **************采购需求*******************/
  620: 'DemandPlanDetail', // 采购方案 - 方案详情

  /** **************履约验收 - 微服务 *******************/
  701: {
    // 采购人-采购方案审批
    type: 'wujie',
    // 无界名称
    name: 'performance',
    toRouter: {
      [platformFunctionModuleDict.PURCHASER.right]: {
        // 采购人-任务审批
        // 云采购路由名称
        name: 'LandlordProject',
        // 无界内部页面path
        linkFun: params =>
          `/Landlord/${params.orderId || 0}/LandlordProgrammeCheck`
      }
    }
  },
  702: {
    type: 'wujie',
    name: 'performance',
    toRouter: {
      [platformFunctionModuleDict.PURCHASER.right]: {
        // 采购人-任务审批
        name: 'LandlordProject',
        linkFun: params => `/${params.taskId || 0}/LandlordTaskExamine`
      },
      [platformFunctionModuleDict.AGENCY.right]: {
        // 代理机构-任务审批
        name: 'AgentProject',
        linkFun: params => `/${params.taskId || 0}/AgentTaskExamine`
      }
    }
  },
  703: {
    type: 'wujie',
    name: 'performance',
    toRouter: {
      [platformFunctionModuleDict.PURCHASER.right]: {
        // 采购人-任务整改审批
        name: 'LandlordProject',
        linkFun: params => `/${params.taskId || 0}/LandlordTaskReformDetail`
      },
      [platformFunctionModuleDict.AGENCY.right]: {
        // 代理机构-任务整改审批
        name: 'AgentProject',
        linkFun: params => `/${params.taskId || 0}/AgentTaskReformDetail`
      }
    }
  },

  /** ************** W-外链 M-门户 ************ */
  WM001: {
    // 门户 - 公告详情
    type: 'outSide',
    linkFun: params =>
      `${process.env.VUE_APP_PORTAL_URL}/project/notice/${params.noticeId}`
  },
  WM002: {
    type: 'outSide',
    linkFun: params =>
      `${process.env.VUE_APP_PORTAL_URL}/company/${params.companyId}`
  },
  WM003: {
    // 门户-帮助中心
    type: 'outSide',
    linkFun: () =>
      `${process.env.VUE_APP_PORTAL_URL}/help?type=TBDW&alias=CAFAQ`
  },
  WM004: {
    // 门户-招募支付页面
    type: 'outSide',
    linkFun: params => `${process.env.VUE_APP_PORTAL_URL}/project/pay/recruit-service?orderId=${params.orderId}&paymentId=${params.srmPaymentId}&supplierId=${params.supplierId}`
  }
}

// 消息通知类型
export const noticeTypeDict = new Dict({
  UNREAD: {
    value: 0,
    label: '未读信息'
  },
  READ: {
    value: 1,
    label: '已读信息'
  }
})

export const articleAliasDict = new Dict({
  PRODUCT_NOTICE: {
    label: '产品公告',
    value: 'CPGG',
    alias: 'CPGG'
  },
  NEWS: {
    label: '新闻中心',
    value: 'XWZX',
    alias: 'XWZX'
  },
  INDUSTRY_NEWS: {
    label: '行业资讯',
    value: 'HYZX',
    alias: 'HYZX'
  },
  INDUSTRY_NEWS_ARTICLE: {
    label: '行业资讯推荐文章',
    value: 'HYWZTJ',
    alias: 'HYWZTJ'
  },
  FAQ: {
    label: '常见问题',
    value: 'CJWT',
    alias: 'CJWT'
  },
  OPERATE_MANUAL: {
    label: '操作手册',
    value: 'CZSC',
    alias: 'CZSC'
  },
  QUICK_START: {
    label: '快速入门',
    value: 'KSRM',
    alias: 'KSRM'
  },
  DEMAND_RESEARCH: {
    label: '需求调查',
    value: 'XQDC',
    alias: 'XQDC'
  },
  EXPERT_MANAGE_RULES: {
    label: '专家管理制度',
    value: 'ZJGL',
    alias: 'ZJGL'
  },
  EXPERT_NOTICE: {
    label: '专家公告通知',
    value: 'ZJGG',
    alias: 'ZJGG'
  },
  EXPERT_DOWNLOAD: {
    label: '专家相关下载',
    value: 'ZJXGXZ',
    alias: 'ZJXGXZ'
  },
  VALUE_ADDED_SERVICE: {
    label: '增值服务',
    value: 'VAS',
    alias: 'VAS'
  },
  PLATFORM_NOTICE: {
    label: '平台公告',
    value: 'PTGG',
    alias: 'PTGG'
  }
})
